var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.1866,
    cy: 19.328,
    rx: 18.8133,
    ry: 18.8133,
    fill: "#7CB6E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3135 26.4817C22.7427 26.4817 26.2593 21.0147 26.2593 16.2743C26.2593 16.1187 26.2593 15.9642 26.2491 15.8104C26.9331 15.3033 27.5235 14.6737 27.9929 13.9533C27.3557 14.2435 26.6784 14.4339 25.9858 14.5178C26.7151 14.0693 27.2611 13.3647 27.5227 12.5332C26.836 12.9511 26.0855 13.2461 25.3026 13.4043C23.9788 11.96 21.7647 11.89 20.3565 13.2487C19.4493 14.1247 19.0634 15.4309 19.3454 16.6767C16.535 16.5316 13.9163 15.1695 12.1409 12.9287C11.2132 14.5679 11.6877 16.6643 13.2237 17.7169C12.6674 17.7003 12.123 17.5466 11.6366 17.2686V17.3141C11.6374 19.0216 12.8105 20.4918 14.441 20.8302C13.9265 20.9744 13.3864 20.9953 12.8633 20.8913C13.3208 22.3531 14.6335 23.3543 16.1286 23.3832C14.8908 24.3816 13.3617 24.9238 11.7874 24.922C11.5097 24.9212 11.2319 24.9045 10.9551 24.8704C12.5541 25.9231 14.4138 26.4817 16.3135 26.4791",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.1430d3032988aae8b401703a035dee8f.svg";
export { ForwardRef as ReactComponent };